import { FormFieldTypes } from "../../../data/formFieldType";
export const CertificateIssuanceFormData = {
  name: "CertificateIssuanceForm",
  initialState: {
    companyCertNumber: null,
    statusId: null,
  },
  formFields: [
    {
      id: "companyCertNumber",
      lable: "Search by Company Name /Cert Number",
      Field_Name: "Company Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "companyCertNumber",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss:
          "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-3 ",
      },
    },
    {
      id: "statusId",
      lable: "Search by Status",
      Field_Name: "Search by Status",
      fieldType: FormFieldTypes.SELECT,
      dataField: "statusId",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss:
          "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-3 xero-filters",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
